import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { API_HOST } from '@/config';
import { useToast } from '@/hooks/useToast';
import { Bot, ErrorMessage, extractServerErrorMsg, BOTS_QUERY_KEY } from '@/queries';
import { queryClient } from '@/reactQueryClient';
import client, { ApiRoutes } from '@/store/client';
import { CreateBotRequest } from '../types';

export const useCreateBot = () => {
  const { toast } = useToast();

  const createBotMutation = useMutation(
    ({ orgId, ...body }: CreateBotRequest) => {
      return client.post<Bot>(
        `${API_HOST}/${ApiRoutes.Core}/organisations/${orgId}/bots`,
        body,
      );
    },
    {
      onError: (errorResponse: AxiosError) => {
        toast(extractServerErrorMsg(errorResponse, 'Failed to create Bot'), {
          variant: 'error',
        });
      },
      onSuccess: (_, { orgId }) => {
        queryClient.invalidateQueries([BOTS_QUERY_KEY, orgId]);
        toast('Bot created.', {
          variant: 'success',
        });
      },
    },
  );

  const { mutateAsync: createBot, isLoading, error } = createBotMutation;
  const serverErrors: ErrorMessage[] = error?.response?.data?.errors || [];

  return { isLoading, serverErrors, createBot };
};
